export default "__VITE_ASSET__B4a919Od__"